import styles from '../../styles.module.scss';
import { ChangeEvent, Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Collapse, FormControlLabel, Radio } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import Cropper from 'cropperjs';
import {
  createFileFromUrl,
  notifyMessagesQuiltMemorialUpdateCreate,
  getListWithIdByListArray,
  getArrayListWithoutId,
  getFullDate,
  notifyMessagesQuiltUpdateCreate,
} from 'utilities';
import { useTranslates } from 'providers/translates';
import { 
  TDefaultListValue, 
  TQuiltCreateUpdate 
} from 'api/http-client/types';
import { editUnpublishedQuilt } from 'api/http-client/queries/quiltQueries';

import {
  createQuilt,
  deleteQuiltImg,
  editQuilt,
  postPhotoToQuiltAlbum,
  publishDraft,
  uploadQuiltImg,
} from 'api/http-client/queries/quilts';
import { showDialog } from 'store/reducers/dialogsSlice';
import { setEditableQuiltState, setIsTriggerResetValuesComparing } from 'store/reducers/quiltSlice';
import {
  useAppDispatch,
  useAppSelector,
  useRedirectAndScroll,
  useQuilt,
  useIsMounted,
} from 'hooks';
import { ImageTypeModel } from '../../../CreateMemorialQuiltStepThree/model';
import { CreateMemorialQuiltStepOneProps, DateInput, IArraysData, TFields, TFieldsDate, TQuilt } from '../../model';
import { defaultValueList } from '../../const';
import { setIsSave, setOpen } from 'store/reducers/notifySlice';
import { AUTOSAVE_INTERVAL, STEP_ONE_SNAPSHOT_KEY } from '../../../constants/constants';
import { getBase64Array } from '../../../helpers/file-to-base64';
import { getFilesFromBase64 } from '../../../helpers/base64-to-blob';
import { Base64WithName } from '../../../types';
import { CreateMemorialFooter } from '../../../CreateMemorialFooter';
import { MandatoryText } from '../../components/MandatoryText';
import { Remembering } from '../../components/Remembering';
import { ServiceInformation } from '../../components/ServiceInformation';
import { ArrayInput } from '../../components/ArrayInput';
import { DetailsInput } from '../../components/DetailsInput';
import { CustomDateInput } from '../../components/CustomDateInput';
import { Loader } from 'components/Loader/Loader';
import { CreateImagesBlock, CreateImagesBlockLocal } from 'components/CreateMemorialQuiltComponents/components';
import { useAuth } from 'providers/auth-provider';
import { TProfile } from 'api/http-client/profileTypes';
import { Language } from 'providers/translates/enums';

export const FormVac: React.FC<CreateMemorialQuiltStepOneProps> = ({
  isStepOneUpdated,
  isActiveStep,
  steps
}) => {
  const { id } = useParams();
  const [, setSearchParams] = useSearchParams();
  const auth = useAuth();
  const user = auth.user as unknown as TProfile;
  const preferredLanguage = user.preferredLanguage ?? Language.ENGLISH;

  const { translates: t } = useTranslates();
  const deceasedRadioButton = t?.quiltBuilderStepOne?.deceasedRadioButton;
  const tellUsAboutVeteran = t?.quiltBuilderStepOne?.tellUsAboutVeteran;
  const addAPhoto = t?.quiltBuilderStepOne?.addAPhoto;
  const personalInformationFieldsSection = t?.quiltBuilderStepOne?.personalInformationFieldsSection;
  const successfullyDeletedPhotoPopUp = t?.quiltBuilderStepOne?.successfullyDeletedPhotoPopUp;

  const dispatch = useAppDispatch();
  const editableQuiltStore = useAppSelector((state) => state.quilt.editableQuilt);
  const { redirectAndScroll, onlyScroll, onlyRedirect } = useRedirectAndScroll({});
  const { loading: loadingPublish } = useQuilt({ id: id || '' });
  const isMounted = useIsMounted();
  const [loading, setLoading] = useState(false);
  const [showAddImages, setShowAddImages] = useState(false);

  const [fileImage, setFileImage] = useState<File | null>();
  const [fileImageUrl, setFileImageUrl] = useState<string>();
  const [currentCrop, setCurrentCrop] = useState<Cropper | null>(null);
  
  const [communityInvolvements, setCommunityInvolvements] = useState<TDefaultListValue[]>(
    editableQuiltStore.communityInvolvements && editableQuiltStore.communityInvolvements.length !== 0
      ? (getListWithIdByListArray(editableQuiltStore.communityInvolvements) as TDefaultListValue[])
      : defaultValueList
  );
  const [placesOfResidence, setPlacesOfResidence] = useState<TDefaultListValue[]>(
    editableQuiltStore.placesOfResidence && editableQuiltStore.placesOfResidence.length !== 0
      ? (getListWithIdByListArray(editableQuiltStore.placesOfResidence) as TDefaultListValue[])
      : defaultValueList
  );
  const [educations, setEducations] = useState<TDefaultListValue[]>(
    editableQuiltStore.educations && editableQuiltStore.educations.length !== 0
      ? (getListWithIdByListArray(editableQuiltStore.educations) as TDefaultListValue[])
      : defaultValueList
  );
  const [hobbiesAndPasttimes, setHobbiesAndPasttimes] = useState<TDefaultListValue[]>(
    editableQuiltStore.hobbiesAndPasttimes && editableQuiltStore.hobbiesAndPasttimes.length !== 0
      ? (getListWithIdByListArray(editableQuiltStore.hobbiesAndPasttimes) as TDefaultListValue[])
      : defaultValueList
  );
  const [forces, setForces] = useState<TDefaultListValue[]>(
    editableQuiltStore?.forces && editableQuiltStore.forces.length !== 0
      ? (getListWithIdByListArray(editableQuiltStore.forces) as TDefaultListValue[])
      : defaultValueList
  );
  const [units, setUnits] = useState<TDefaultListValue[]>(
    editableQuiltStore?.units && editableQuiltStore.units.length !== 0
      ? (getListWithIdByListArray(editableQuiltStore.units) as TDefaultListValue[])
      : defaultValueList
  );
  const [troops, setTroops] = useState<TDefaultListValue[]>(
    editableQuiltStore?.troops && editableQuiltStore.troops.length !== 0
      ? (getListWithIdByListArray(editableQuiltStore.troops) as TDefaultListValue[])
      : defaultValueList
  );
  const [divisions, setDivisions] = useState<TDefaultListValue[]>(
    editableQuiltStore?.divisions && editableQuiltStore.divisions.length !== 0
      ? (getListWithIdByListArray(editableQuiltStore.divisions) as TDefaultListValue[])
      : defaultValueList
  );
  const [regiments, setRegiments] = useState<TDefaultListValue[]>(
    editableQuiltStore?.regiments && editableQuiltStore.regiments.length !== 0
      ? (getListWithIdByListArray(editableQuiltStore.regiments) as TDefaultListValue[])
      : defaultValueList
  );
  const [detachmentsSectionsUnits, setDetachment] = useState<TDefaultListValue[]>(
    editableQuiltStore?.detachmentsSectionsUnits && editableQuiltStore.detachmentsSectionsUnits.length !== 0
      ? (getListWithIdByListArray(editableQuiltStore.detachmentsSectionsUnits) as TDefaultListValue[])
      : defaultValueList
  );
  const [toursOfDuty, setToursOfDuty] = useState<TDefaultListValue[]>(
    editableQuiltStore?.toursOfDuty && editableQuiltStore.toursOfDuty.length !== 0
      ? (getListWithIdByListArray(editableQuiltStore.toursOfDuty) as TDefaultListValue[])
      : defaultValueList
  );
  const [postings, setPostings] = useState<TDefaultListValue[]>(
    editableQuiltStore?.postings && editableQuiltStore.postings.length !== 0
      ? (getListWithIdByListArray(editableQuiltStore.postings) as TDefaultListValue[])
      : defaultValueList
  );
  const [awardsAndHonors, setAwardsAndHonors] = useState<TDefaultListValue[]>(
    editableQuiltStore?.awardsAndHonors && editableQuiltStore.awardsAndHonors.length !== 0
      ? (getListWithIdByListArray(editableQuiltStore.awardsAndHonors) as TDefaultListValue[])
      : defaultValueList
  );
  const [dateOfBirthInput, setDateOfBirthInput] = useState<DateInput>({
    day: editableQuiltStore.dateOfBirth?.day ? getFullDate(editableQuiltStore.dateOfBirth) : null,
    month: editableQuiltStore.dateOfBirth?.month
      ? getFullDate(editableQuiltStore.dateOfBirth)
      : null,
    year: editableQuiltStore.dateOfBirth?.year ? getFullDate(editableQuiltStore.dateOfBirth) : null,
  });
  const [dateOfPassingInput, setDateOfPassingInput] = useState<DateInput>({
    day: editableQuiltStore.dateOfPassing?.day
      ? getFullDate(editableQuiltStore.dateOfPassing)
      : null,
    month: editableQuiltStore.dateOfPassing?.month
      ? getFullDate(editableQuiltStore.dateOfPassing)
      : null,
    year: editableQuiltStore.dateOfPassing?.year
      ? getFullDate(editableQuiltStore.dateOfPassing)
      : null,
  });
  const [enlistmentDate, setEnlistmentDate] = useState<DateInput>({
    day: editableQuiltStore.enlistmentDate?.day ? getFullDate(editableQuiltStore.enlistmentDate) : null,
    month: editableQuiltStore.enlistmentDate?.month
      ? getFullDate(editableQuiltStore.enlistmentDate)
      : null,
    year: editableQuiltStore.enlistmentDate?.year ? getFullDate(editableQuiltStore.enlistmentDate) : null,
  });
  const [filesImages, setFilesImages] = useState<File[]>([]);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const isInit = useRef(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const imageRef = useRef<HTMLImageElement>(null);
  const intervalId = useRef<NodeJS.Timeout | null>(null);
  const savedDataRef = useRef<{filesImages: Base64WithName[], editableQuiltStore: TQuilt} | null>({
    filesImages: [],
    editableQuiltStore: {}
  });

  const setInitData = (editableQuilt: TQuilt) => {
    editableQuilt?.previewImageUrl
      ? setFileImageUrl(editableQuilt?.previewImageUrl)
      : editableQuilt?.finalImage?.full && setFileImageUrl(editableQuilt.finalImage.full);
    editableQuilt?.communityInvolvements?.length &&
      setCommunityInvolvements(getListWithIdByListArray(editableQuilt.communityInvolvements));
    editableQuilt?.placesOfResidence?.length &&
      setPlacesOfResidence(getListWithIdByListArray(editableQuilt.placesOfResidence));
    editableQuilt?.educations?.length &&
      setEducations(getListWithIdByListArray(editableQuilt.educations));
    editableQuilt?.hobbiesAndPasttimes?.length &&
      setHobbiesAndPasttimes(getListWithIdByListArray(editableQuilt.hobbiesAndPasttimes));
    editableQuilt?.forces?.length &&
      setForces(getListWithIdByListArray(editableQuilt.forces));
    editableQuilt?.units?.length &&
      setUnits(getListWithIdByListArray(editableQuilt.units));
    editableQuilt?.troops?.length &&
      setTroops(getListWithIdByListArray(editableQuilt.troops));
    editableQuilt?.divisions?.length &&
      setDivisions(getListWithIdByListArray(editableQuilt.divisions));
    editableQuilt?.regiments?.length &&
      setRegiments(getListWithIdByListArray(editableQuilt.regiments));
    editableQuilt?.detachmentsSectionsUnits?.length &&
      setDetachment(getListWithIdByListArray(editableQuilt.detachmentsSectionsUnits));
    editableQuilt?.toursOfDuty?.length &&
      setToursOfDuty(getListWithIdByListArray(editableQuilt.toursOfDuty));
    editableQuilt?.postings?.length &&
      setPostings(getListWithIdByListArray(editableQuilt.postings));
    editableQuilt?.awardsAndHonors?.length &&
      setAwardsAndHonors(getListWithIdByListArray(editableQuilt.awardsAndHonors));

    setDateOfBirthInput({
      day: editableQuilt.dateOfBirth?.day ? getFullDate(editableQuilt.dateOfBirth) : null,
      month: editableQuilt.dateOfBirth?.month
        ? getFullDate(editableQuilt.dateOfBirth)
        : null,
      year: editableQuilt.dateOfBirth?.year
        ? getFullDate(editableQuilt.dateOfBirth)
        : null,
    });
    setDateOfPassingInput({
      day: editableQuilt.dateOfPassing?.day
        ? getFullDate(editableQuilt.dateOfPassing)
        : null,
      month: editableQuilt.dateOfPassing?.month
        ? getFullDate(editableQuilt.dateOfPassing)
        : null,
      year: editableQuilt.dateOfPassing?.year
        ? getFullDate(editableQuilt.dateOfPassing)
        : null,
    });
    setEnlistmentDate({
      day: editableQuilt.enlistmentDate?.day
        ? getFullDate(editableQuilt.enlistmentDate)
        : null,
      month: editableQuilt.enlistmentDate?.month
        ? getFullDate(editableQuilt.enlistmentDate)
        : null,
      year: editableQuilt.enlistmentDate?.year
        ? getFullDate(editableQuilt.enlistmentDate)
        : null,
    });
    
    if (editableQuilt.finalImage?.originalFileName) {
      setSelectedImage(editableQuilt.finalImage?.originalFileName);
    }
  }

  // reset in a create mode
  useEffect(() => {
    dispatch(setEditableQuiltState({...editableQuiltStore, lang: editableQuiltStore.lang ?? preferredLanguage}))

    if (isStepOneUpdated && editableQuiltStore.id !== undefined) {
      onlyRedirect(`/update/${editableQuiltStore.id}?step=${1}`);
      return;
    }

    if (intervalId.current !== null) {
      clearInterval(intervalId.current);
    }

    intervalId.current = setInterval(async () => {
      localStorage.setItem(STEP_ONE_SNAPSHOT_KEY, JSON.stringify(savedDataRef.current));
    }, AUTOSAVE_INTERVAL);

    const temp = localStorage.getItem(STEP_ONE_SNAPSHOT_KEY);

    if (temp !== null) {
      const savedQuilt = JSON.parse(temp) as {filesImages: Base64WithName[], editableQuiltStore: TQuilt};
      dispatch(setEditableQuiltState(savedQuilt.editableQuiltStore));

      setInitData(savedQuilt?.editableQuiltStore);

      savedQuilt.filesImages && setFilesImages(getFilesFromBase64(savedQuilt.filesImages));
    }
    
    return () => {
      if (intervalId.current !== null) {
        clearInterval(intervalId.current);
      }
    }
  }, []);

  useEffect(() => {
    (async () => {
      const {id, ...rest} = editableQuiltStore;

      savedDataRef.current = {
        filesImages: await getBase64Array(filesImages),
        editableQuiltStore: {
          ...rest,
          ...getArraysData()
        }
      }
    })()
  }, [
    editableQuiltStore,
    filesImages,
    communityInvolvements,
    placesOfResidence,
    educations,
    hobbiesAndPasttimes,
    forces,
    units,
    troops,
    divisions,
    regiments,
    detachmentsSectionsUnits,
    toursOfDuty,
    postings,
    awardsAndHonors,
    dateOfBirthInput,
    dateOfPassingInput,
    enlistmentDate
  ]);

  // init
  useEffect(() => {
    if (!editableQuiltStore || !id || !Object.keys(editableQuiltStore).length) return;
    if (isInit.current) return;

    setInitData(editableQuiltStore);

    isInit.current = true;
  }, [editableQuiltStore, id]);

  useEffect(() => {
    if (!imageRef.current) return;

    if (currentCrop && fileImage) {
      currentCrop.replace(URL.createObjectURL(fileImage));
    } else {
      setCurrentCrop(new Cropper(imageRef.current));
    }
  }, [imageRef, fileImage, currentCrop]);

  // effects for updating date in store (date, list)
  useEffect(() => {
    if (!isMounted) return;
    setDateStore('dateOfPassing');
  }, [dateOfPassingInput]);

  useEffect(() => {
    if (!isMounted) return;
    setDateStore('dateOfBirth');
  }, [dateOfBirthInput]);

  useEffect(() => {
    if (!isMounted) return;
    setDateStore('enlistmentDate');
  }, [enlistmentDate]);

  useEffect(() => {
    if (!isMounted) return;

    dispatch(setEditableQuiltState({ ...editableQuiltStore, ...getArraysData() }));
  }, [
    communityInvolvements, 
    placesOfResidence, 
    educations, 
    hobbiesAndPasttimes,
    forces,
    units,
    troops,
    divisions,
    regiments,
    detachmentsSectionsUnits,
    toursOfDuty,
    postings,
    awardsAndHonors
  ]);

  const openImageChoosing = () => {
    setShowAddImages(true);
    onlyScroll('addPhoto');
  };

  const accessibleToCreate = () => {
    if (!editableQuiltStore) return false;

    return (
      !editableQuiltStore.firstName ||
      !editableQuiltStore.lastName
    );
  };

  const getDateFromInput = (date: DateInput) => {
    const day = date.day ? new Date(date.day).getDate() : null;
    const month = date.month ? new Date(date.month).getMonth() : null;
    const year = date.year ? new Date(date.year).getFullYear() : 1970;
    return new Date(year, month ? month : 0, day || 1);
  };

  const getQuilt = (id: string) => {
    return editUnpublishedQuilt(id).then((res) => {
      dispatch(setEditableQuiltState(res));
      res?.finalImage?.full && setFileImageUrl(res.finalImage.full);
      res?.communityInvolvements?.length
        ? setCommunityInvolvements(getListWithIdByListArray(res.communityInvolvements))
        : setCommunityInvolvements(defaultValueList);
      res?.placesOfResidence?.length
        ? setPlacesOfResidence(getListWithIdByListArray(res.placesOfResidence))
        : setPlacesOfResidence(defaultValueList);
      res?.educations?.length
        ? setEducations(getListWithIdByListArray(res.educations))
        : setEducations(defaultValueList);
      res?.hobbiesAndPasttimes?.length
        ? setHobbiesAndPasttimes(getListWithIdByListArray(res.hobbiesAndPasttimes))
        : setHobbiesAndPasttimes(defaultValueList);
      res?.forces?.length
        ? setForces(getListWithIdByListArray(res.forces))
        : setForces(defaultValueList);
      res?.units?.length
        ? setUnits(getListWithIdByListArray(res.units))
        : setUnits(defaultValueList);
      res?.troops?.length
        ? setTroops(getListWithIdByListArray(res.troops))
        : setTroops(defaultValueList);
      res?.divisions?.length
        ? setDivisions(getListWithIdByListArray(res.divisions))
        : setDivisions(defaultValueList);
      res?.regiments?.length
        ? setRegiments(getListWithIdByListArray(res.regiments))
        : setRegiments(defaultValueList);
      res?.detachmentsSectionsUnits?.length
        ? setDetachment(getListWithIdByListArray(res.detachmentsSectionsUnits))
        : setDetachment(defaultValueList);
      res?.toursOfDuty?.length
        ? setToursOfDuty(getListWithIdByListArray(res.toursOfDuty))
        : setToursOfDuty(defaultValueList);
      res?.postings?.length
        ? setPostings(getListWithIdByListArray(res.postings))
        : setPostings(defaultValueList);
      res?.awardsAndHonors?.length
        ? setAwardsAndHonors(getListWithIdByListArray(res.awardsAndHonors))
        : setAwardsAndHonors(defaultValueList);
    });
  };

  const uploadFinalImage = (id: string, img: File) => {
    setLoading(true);
    uploadQuiltImg(id, img)
      .then((resp) => {
        resp.success &&
          dispatch(setEditableQuiltState({ ...editableQuiltStore, finalImage: resp.returned }));
        setFileImageUrl(resp.returned.full);
      })
      .finally(() => setLoading(false));
  };

  const getArraysData = (): IArraysData => {
    return {
      placesOfResidence: getArrayListWithoutId(placesOfResidence),
      educations: getArrayListWithoutId(educations),
      hobbiesAndPasttimes: getArrayListWithoutId(hobbiesAndPasttimes),
      communityInvolvements: getArrayListWithoutId(communityInvolvements),
      forces: getArrayListWithoutId(forces),
      units: getArrayListWithoutId(units),
      troops: getArrayListWithoutId(troops),
      divisions: getArrayListWithoutId(divisions),
      regiments: getArrayListWithoutId(regiments),
      detachmentsSectionsUnits: getArrayListWithoutId(detachmentsSectionsUnits),
      toursOfDuty: getArrayListWithoutId(toursOfDuty),
      postings: getArrayListWithoutId(postings),
      awardsAndHonors: getArrayListWithoutId(awardsAndHonors)
    }
  };

  const initEditableQuiltValuesRequest = (): TQuiltCreateUpdate => {
    if (!editableQuiltStore) return {};

    return {
      lastName: editableQuiltStore?.lastName || '',
      firstName: editableQuiltStore?.firstName || '',
      dateOfBirth: editableQuiltStore.dateOfBirth,
      dateOfPassing: editableQuiltStore.dateOfPassing,
      enlistmentDate: editableQuiltStore?.enlistmentDate,
      ...getArraysData(),
      hometown: editableQuiltStore?.hometown || '',
      placeOfBurial: editableQuiltStore?.placeOfBurial || '',
      serviceNumber: editableQuiltStore?.serviceNumber || '',
      regimentalNumber: editableQuiltStore?.regimentalNumber || '',
      inMemorialDonation: editableQuiltStore?.inMemorialDonation || '',
      donationLink: editableQuiltStore?.donationLink || '',
      isEnableTributesAndCondolence: editableQuiltStore?.isEnableTributesAndCondolence || false,
      isDeceased: editableQuiltStore?.isDeceased || false,
      isPublic: editableQuiltStore?.isPublic || true,
      isPublished: editableQuiltStore?.isPublished || false,
      lang: editableQuiltStore.lang ?? preferredLanguage
    };
  };

  const create = async () => {
    const id = await createQuilt(initEditableQuiltValuesRequest())
      .then((id) => id.toString())
      .catch(() => {
        dispatch(
          setOpen(
            t?.notifyMessagesQuiltMemorialUpdateCreate?.quiltCreatedError ||
              notifyMessagesQuiltMemorialUpdateCreate.quiltCreatedError
          )
        );
      });

    return id;
  };

  const validateDateOfBirthAndDateOfPassing = (): boolean => {
    if (accessibleToCreate()) {
      dispatch(
        setOpen(
          t?.notifyMessagesQuiltMemorialUpdateCreate?.quiltRequiredFieldsInfo ||
            notifyMessagesQuiltMemorialUpdateCreate.quiltRequiredFieldsInfo
        )
      );
      return false;
    }

    if (
      (dateOfBirthInput.day && !dateOfBirthInput.month) ||
      (dateOfPassingInput.day && !dateOfPassingInput.month)
    ) {
      dispatch(
        setOpen(
          t?.notifyMessagesQuiltMemorialUpdateCreate?.quiltUpdatedError ||
            notifyMessagesQuiltMemorialUpdateCreate.validateDayWithoutMonth
        )
      );
      return false;
    }

    if (dateOfPassingInput.year !== null) {
      if (getDateFromInput(dateOfBirthInput) > getDateFromInput(dateOfPassingInput)) {
        dispatch(
          setOpen(
            t?.notifyMessagesQuiltMemorialUpdateCreate?.quiltUpdatedError ||
              notifyMessagesQuiltMemorialUpdateCreate.validDateOfBirthOrDeath
          )
        );
        return false;
      }
    }

    if (
      getDateFromInput(dateOfBirthInput) > new Date() ||
      getDateFromInput(dateOfPassingInput) > new Date()
    ) {
      dispatch(
        setOpen(
          t?.notifyMessagesQuiltMemorialUpdateCreate?.quiltUpdatedError ||
            notifyMessagesQuiltMemorialUpdateCreate.validateFutureDate
        )
      );
      return false;
    }

    return true;
  }

  const onCreate = async (nextStep?: boolean) => {
    if (!editableQuiltStore) return;
    if (editableQuiltStore.id) return editableQuiltStore.id;

    if (!validateDateOfBirthAndDateOfPassing()) {
      return;
    }
    setLoading(true);

    const id = await create()
      .then((id) => {
        if (!id) return '';

        if (fileImageUrl) {
          createFileFromUrl(fileImageUrl, selectedImage ?? 'image').then((image) => {
            uploadFinalImage(id, image);

            dispatch(
              setOpen(
                t?.notifyMessagesQuiltMemorialUpdateCreate?.quiltCreatedSuccess ||
                  notifyMessagesQuiltMemorialUpdateCreate.quiltCreatedSuccess
              )
            );
          });
        }

        if (filesImages.length > 0) {
          return Promise
            .all(filesImages.map(async (file) => postPhotoToQuiltAlbum(id, file)))
            .then(() => id);
        } else {
          return id;
        }
      })
      .finally(() => {
        setLoading(false);
      });

    id &&
      editUnpublishedQuilt(id).then((res) => {
        res && dispatch(setEditableQuiltState(res));
      });

    nextStep && id && redirectAndScroll(`/update/${id}?step=2`);
    return id;
  };

  const onPreview = async () => {
    if (accessibleToCreate()) {
      dispatch(
        setOpen(
          t?.notifyMessagesQuiltMemorialUpdateCreate?.quiltRequiredFieldsInfo ||
            notifyMessagesQuiltMemorialUpdateCreate.quiltRequiredFieldsInfo
        )
      );
      return;
    }
    localStorage.setItem(STEP_ONE_SNAPSHOT_KEY, JSON.stringify(savedDataRef.current));
    showDialogBlocks();
  };

  const onUpdate = async () => {
    if (!editableQuiltStore) return;
    if (!editableQuiltStore.id) return;

    if (!validateDateOfBirthAndDateOfPassing()) {
      return;
    }

    setLoading(true);

    await editQuilt(editableQuiltStore.id, initEditableQuiltValuesRequest())
      .then(() => {
        if (fileImageUrl) {
          return createFileFromUrl(fileImageUrl, selectedImage ?? 'image');
        }
      })
      .then((image) => {
        if (image) {
          uploadFinalImage(`${editableQuiltStore.id}`, image);
        }

        if (editableQuiltStore.isPublished && editableQuiltStore.id && !editableQuiltStore.finalImage) {
          return publishDraft(editableQuiltStore.id, editableQuiltStore.isPublished)
        }
      })
      .then(() => {
        if (editableQuiltStore.isPublished && editableQuiltStore.id && !editableQuiltStore.finalImage) {
          dispatch(setEditableQuiltState({...editableQuiltStore, isPublished: false}))
        }
        dispatch(
          setOpen(
            t?.notifyMessagesQuiltMemorialUpdateCreate?.quiltUpdatedSuccess ||
              notifyMessagesQuiltMemorialUpdateCreate.quiltUpdatedSuccess
          )
        );
      })
      .then(() => {
        editableQuiltStore.id &&
          getQuilt(editableQuiltStore.id).then(() => {
            setSearchParams({
              step: '2',
            });
            dispatch(setIsTriggerResetValuesComparing(true));
          });
      })
      .catch(() =>
        dispatch(
          setOpen(
            t?.notifyMessagesQuiltMemorialUpdateCreate?.quiltUpdatedError ||
              notifyMessagesQuiltMemorialUpdateCreate.quiltUpdatedError
          )
        )
      )
      .finally(() => {
        setLoading(false);
      });
  };

  const changeImage = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;

    if (!files) return;

    setFileImage(files[0]);
  };

  const setImage = () => {
    if (!currentCrop) return;

    setFileImageUrl(currentCrop.getCroppedCanvas().toDataURL('image/png'));

    currentCrop.destroy();
    setCurrentCrop(null);
    setFileImage(null);
  };

  const removeImage = () => {
    if (!id) return;

    setLoading(true);

    deleteQuiltImg(id)
      .then(() => {
        setFileImageUrl('');
        if (editableQuiltStore?.finalImage) {
          dispatch(setEditableQuiltState({...editableQuiltStore, finalImage: null}))
        }
        dispatch(setOpen(successfullyDeletedPhotoPopUp?.successfullyDeletedPhotoText ?? notifyMessagesQuiltUpdateCreate.one.imageDelete));
      })
      .catch((e) => {
        if (e?.errors) {
          dispatch(setOpen(e.errors));
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const showDialogBlocks = () => {
    dispatch(showDialog('blocks'));
  };

  const setIsDeceased = (event: any) => {
    if (!editableQuiltStore) return;

    if (!!editableQuiltStore.isDeceased) {
      dispatch(
        setEditableQuiltState({ ...editableQuiltStore, isDeceased: false })
      );
    } else {
      dispatch(
        setEditableQuiltState({
          ...editableQuiltStore,
          isDeceased: !!event.target.value,
        })
      );
    }
  };

  const setImageBlock = (image: ImageTypeModel | null) => {
    if (!image) {
      setShowAddImages(false);
      return;
    }

    setSelectedImage(image.originalImage);
    setFileImageUrl(image.file);
    dispatch(setEditableQuiltState({ ...editableQuiltStore, previewImageUrl: image.file }));
    setShowAddImages(false);
  };

  const setValueToEditableQuilt = (key: TFields, value: string) => {
    const data = { ...editableQuiltStore };

    if (!value) {
      delete data[key];
    }

    dispatch(setEditableQuiltState({ ...data, ...(value ? { [key]: value } : {}) }));
  };

  const handleSetYear = (nameDate: TFieldsDate, date: Date | null) => {
    let action: Dispatch<SetStateAction<DateInput>>;

    if (nameDate === 'dateOfPassing') {
      action = setDateOfPassingInput;
    } else if (nameDate === 'dateOfBirth') {
      action = setDateOfBirthInput;
    } else {
      action = setEnlistmentDate;
    }

    action((d) => ({
      ...d,
      year: date ? new Date(date) : null,
    }));
  };

  const handleSetMonth = (nameDate: TFieldsDate, date: Date | string | null) => {
    let action: Dispatch<SetStateAction<DateInput>>;

    if (nameDate === 'dateOfPassing') {
      action = setDateOfPassingInput;
    } else if (nameDate === 'dateOfBirth') {
      action = setDateOfBirthInput;
    } else {
      action = setEnlistmentDate;
    }

    action((d) => ({
      ...d,
      month: date
        ? d.year
          ? new Date((date as Date).setFullYear(d.year.getFullYear()))
          : new Date(date)
        : null,
    }));
  };

  const handleSetDay = (nameDate: TFieldsDate, date: Date | null) => {
    let action: Dispatch<SetStateAction<DateInput>>;

    if (nameDate === 'dateOfPassing') {
      action = setDateOfPassingInput;
    } else if (nameDate === 'dateOfBirth') {
      action = setDateOfBirthInput;
    } else {
      action = setEnlistmentDate;
    }

    action((d) => ({
      ...d,
      day: date
        ? d.year && d.month
          ? new Date(new Date(date.setFullYear(d.year.getFullYear())).setMonth(d.month.getMonth()))
          : d.year
            ? new Date(date.setFullYear(d.year.getFullYear()))
            : d.month
              ? new Date(date.setMonth(d.month.getMonth()))
              : new Date(date)
        : null,
    }));
  };

  const setDateStore = (nameDate: TFieldsDate) => {
    let currentDate: DateInput;

    if (nameDate === 'dateOfPassing') {
      currentDate = dateOfPassingInput;
    } else if (nameDate === 'dateOfBirth') {
      currentDate = dateOfBirthInput;
    } else {
      currentDate = enlistmentDate;
    }

    if (!currentDate.day && !currentDate.month && !currentDate.year) {
      const data = { ...editableQuiltStore };

      if (data[nameDate]) {
        delete data[nameDate];
      }

      dispatch(
        setEditableQuiltState({
          ...data,
        })
      );
      return;
    }

    dispatch(
      setEditableQuiltState({
        ...editableQuiltStore,
        [nameDate]: {
          ...editableQuiltStore?.[nameDate],
          ...(currentDate.day
            ? {
                day: new Date(currentDate.day).getDate(),
              }
            : {}),
          ...(currentDate.month
            ? {
                month: new Date(currentDate.month).getMonth() + 1,
              }
            : {}),
          ...(currentDate.year
            ? {
                year: new Date(currentDate.year).getFullYear(),
              }
            : {}),
        },
      })
    );
  };

  const saveAndContinueAction = async () => {
    localStorage.removeItem(STEP_ONE_SNAPSHOT_KEY);
    if (editableQuiltStore?.id) {
      onUpdate();
    } else {
      dispatch(setIsSave(true));
      onCreate(true);
    }
  };

  return (
    <>
      <div className={styles.tributes__radio}>
        <FormControlLabel
          control={
            <Radio
              checked={editableQuiltStore?.isDeceased === true}
              onClick={setIsDeceased}
              value="true"
            />
          }
          componentsProps={{
            typography: {
              color: '#24476A',
              fontSize: { xs: '18px', sm: '22px' },
              fontFamily: 'Open Sans',
            },
          }}
          label={deceasedRadioButton?.deceasedRadioButtonText ?? "I am making this quilt square for someone who is deceased."}
        />
      </div>
      <p className={styles.startText}>
      {tellUsAboutVeteran?.deceasedInformationText ?? (
        <>
          When you check this box, an optional field to enter their date of death will be added. A red maple leaf will also be added to the person's quilt square.
        </>
      )}
      </p>
      <h2 className="defaultTitle">{tellUsAboutVeteran?.tellUsAboutVeteranHeading ?? 'Tell us about the person you are remembering'}</h2>
      <p className={styles.startText}>
      {tellUsAboutVeteran?.requiredInformationText ?? (
        <>
          You must include a first name, last name, year of birth, and year of death. Day and month
          are optional.
        </>
      )}
      </p>

      <Remembering 
        firstName={editableQuiltStore?.firstName}
        lastName={editableQuiltStore?.lastName}
        dateOfBirthInput={dateOfBirthInput}
        dateOfPassingInput={dateOfPassingInput}
        setValueToEditableQuilt={setValueToEditableQuilt}
        handleSetDay={handleSetDay}
        handleSetMonth={handleSetMonth}
        handleSetYear={handleSetYear}
      />

      <MandatoryText />

      <p className={`${styles.startText} ${styles.textWithTopMargin}`}>
        {tellUsAboutVeteran?.whatDisplaysPubliclyInformationText ?? (
          <>
            The person’s name and their years of birth and death will display on the Canadian Healing
            Quilt and help others find your quilt using the search feature.
          </>
        )}
      </p>

      <div className={styles.details}>
        <div className={styles.details__info}>
          <span className="defaultTitle">{addAPhoto?.addAPhotoHeading || 'Add a main photo and details'}</span>
          <p className={styles.startText}>
            {addAPhoto?.addAPhotoIntroText || 'The main photo will be displayed on the Canadian Healing Quilt and is mandatory. Any fields left blank will not be shown on your quilt square.' }
          </p>
        </div>
        <div id="addPhoto">
          <Collapse in={showAddImages} timeout={1000}>
            {id ? (
              <CreateImagesBlock
                setImageBlock={setImageBlock}
                isMain
                isStepOne={true}
                imageName={selectedImage}
                showAddImages={showAddImages}
              />
            ) : (
              <CreateImagesBlockLocal
                filesImages={filesImages}
                setFilesImages={setFilesImages}
                setImageBlock={setImageBlock}
                isStepOne={true}
                imageName={selectedImage}
                showAddImages={showAddImages}
              />
            )}
          </Collapse>
        </div>

        <div className={styles.details__infoActions}>
          {!showAddImages && (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <p className={styles.details__addPhoto_title}>{addAPhoto?.addAPhotoWidgetHeading || 'Add photo'}</p>
              <div className={styles.details__addPhoto}>
                <input
                  type="file"
                  id="fileInputAddImage"
                  ref={fileInputRef}
                  onChange={changeImage}
                  accept="image/png, image/jpeg"
                  style={{
                    display: 'none',
                  }}
                />

                {fileImageUrl ? (
                  <img src={fileImageUrl} alt="uploaded" />
                ) : fileImage ? (
                  <img ref={imageRef} src={URL.createObjectURL(fileImage)} alt={fileImage?.name} />
                ) : (
                  <div className={styles.details__addPhotoInside}>
                    <span>{addAPhoto?.addAPhotoWidgetInstructionText || 'Click to add a photo'}</span>
                    <div className={styles.details__addPhotoInsideSvg} onClick={openImageChoosing}>
                      <AddIcon />
                    </div>
                  </div>
                )}
                {fileImageUrl && (
                  <div className={styles.details__addPhotoActions}>
                    <div className={styles.details__addPhotoActionSvg} onClick={openImageChoosing}>
                      <EditIcon />
                    </div>

                    {!currentCrop ? (
                      <div className={styles.details__addPhotoActionSvg} onClick={removeImage}>
                        <DeleteOutlineIcon />
                      </div>
                    ) : (
                      <div
                        style={{
                          height: '30px',
                          width: '30px',
                        }}
                      ></div>
                    )}
                  </div>
                )}
                {currentCrop && (
                  <div className={styles.details__addPhotoActions} onClick={setImage}>
                    <div className={styles.details__addPhotoActionSvg}>
                      <DoneIcon />
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          <div style={{display: 'flex', flexDirection: 'column', gap: '32px', flexGrow: '1'}}>
            <ServiceInformation 
              forces={forces}
              units={units}
              troops={troops}
              divisions={divisions}
              regiments={regiments}
              detachmentsSectionsUnits={detachmentsSectionsUnits}
              toursOfDuty={toursOfDuty}
              postings={postings}
              awardsAndHonors={awardsAndHonors}
              enlistmentDate={enlistmentDate}
              setForces={setForces}
              setUnits={setUnits}
              setTroops={setTroops}
              setDivisions={setDivisions}
              setRegiments={setRegiments}
              setDetachment={setDetachment}
              setToursOfDuty={setToursOfDuty}
              setPostings={setPostings}
              setAwardsAndHonors={setAwardsAndHonors}
              setValueToEditableQuilt={setValueToEditableQuilt}
              handleSetDay={handleSetDay}
              handleSetMonth={handleSetMonth}
              handleSetYear={handleSetYear}
            />
            <div style={{display: 'flex', flexDirection: 'column', flexGrow: '1'}}>
              <span className={styles.details__title}>{personalInformationFieldsSection?.personalInformationHeading ?? 'Personal Information'}</span>
              <div className={styles.details__inputs}>
                <div className={styles.details__columnInput}>
                  <CustomDateInput
                    title={personalInformationFieldsSection?.birthDateFieldLabel ?? "Date Of Birth"}
                    dateInput={dateOfBirthInput}
                    onChangeDay={(date) => handleSetDay('dateOfBirth', date)}
                    onChangeMonth={(date) => handleSetMonth('dateOfBirth', date)}
                    onChangeYear={(date) => handleSetYear('dateOfBirth', date)}
                  />
                  <ArrayInput
                    title={personalInformationFieldsSection?.residencePlaceFieldLabel ?? 'Place of Residence'}
                    items={placesOfResidence}
                    onSetState={setPlacesOfResidence}
                    placeholder={personalInformationFieldsSection?.residencePlaceFieldDefaultStateText}
                  />
                  <DetailsInput 
                    title={personalInformationFieldsSection?.hometownFieldLabel ?? 'Hometown'}
                    value={editableQuiltStore?.hometown}
                    onChange={({ target }) => {
                      setValueToEditableQuilt('hometown', target.value);
                    }}
                    placeholder={personalInformationFieldsSection?.hometownFieldDefaultStateText || 'Enter information here'}
                  />
                  <ArrayInput
                    title={personalInformationFieldsSection?.educationFieldLabel ?? 'Education'}
                    items={educations}
                    onSetState={setEducations}
                    placeholder={personalInformationFieldsSection?.educationFieldDefaultStateText}
                  />
                  <ArrayInput
                    title={personalInformationFieldsSection?.hobbiesFieldLabel ?? 'Hobbies and pastimes'}
                    items={hobbiesAndPasttimes}
                    onSetState={setHobbiesAndPasttimes}
                    placeholder={personalInformationFieldsSection?.hobbiesFieldDefaultStateText}
                  />
                </div> 
                <div className={styles.details__columnInput}>
                  <ArrayInput
                    title={personalInformationFieldsSection?.communityInvolvementFieldLabel ?? 'Community involvement'}
                    items={communityInvolvements}
                    onSetState={setCommunityInvolvements}
                    placeholder={personalInformationFieldsSection?.communityInvolvementFieldDefaultStateText}
                  />
                  {editableQuiltStore?.isDeceased && (
                    <>
                      <CustomDateInput
                        title={personalInformationFieldsSection?.deathDateFieldLabel ?? "Date Of Death"}
                        dateInput={dateOfPassingInput}
                        onChangeDay={(date) => handleSetDay('dateOfPassing', date)}
                        onChangeMonth={(date) => handleSetMonth('dateOfPassing', date)}
                        onChangeYear={(date) => handleSetYear('dateOfPassing', date)}
                      />
                      <DetailsInput 
                        title={personalInformationFieldsSection?.burialPlaceFieldLabel ?? 'Place of burial'}
                        value={editableQuiltStore?.placeOfBurial}
                        onChange={({ target }) => {
                          setValueToEditableQuilt('placeOfBurial', target.value);
                        }}
                        placeholder={personalInformationFieldsSection?.burialPlaceFieldDefaultStateText ?? 'Enter information here'}
                      />
                      <DetailsInput 
                        title={personalInformationFieldsSection?.donationCharityNameFieldLabel ?? 'DONATION IN MEMORY'}
                        value={editableQuiltStore?.inMemorialDonation}
                        onChange={({ target }) => {
                          setValueToEditableQuilt('inMemorialDonation', target.value);
                        }}
                        placeholder={personalInformationFieldsSection?.donationsCharityNameFieldDefaultStateText ?? 'Charity name'}
                      />
                    </>
                  )}
                  <DetailsInput 
                    title={personalInformationFieldsSection?.donationsLinkFieldLabel ?? 'DONATION LINK'}
                    value={editableQuiltStore?.donationLink}
                    onChange={({ target }) => {
                      setValueToEditableQuilt('donationLink', target.value);
                    }}
                    placeholder={personalInformationFieldsSection?.donationsLinkFieldDefaultStateText ?? 'Copy and paste donation link here'}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <CreateMemorialFooter 
          isStepOne
          showDialogBlocks={onPreview}
          onSave={saveAndContinueAction}
          isActiveStep={isActiveStep}
          steps={steps}
        />
      </div>

      <Loader loading={loading || loadingPublish} />
    </>
  );
}
